<template>
  <div class="submit-container">
    <div class="search-form">
      <tag-check-box label="奖项类别" :options="PRIZE_CATEGORY_EMNU" v-model="searchParams.prizeCategoryValue" />
      <tag-check-box label="奖项状态" :options="PRIZE_STATUS_EMNU" v-model="searchParams.prizeStatusValue" />
    </div>

    <div class="table">
      <a-row class="search" type="flex" justify="start">
        <a-col :span="8">
          <a-input-group compact>
            <a-select v-model="searchParams.searchType" style="display: inline-block; width: 160px">
              <a-select-option value="PROJECT_NAME"> 项目名称 </a-select-option>
            </a-select>
            <a-input style="width: calc(100% - 160px)" placeholder="请输入" />
          </a-input-group>
        </a-col>
        <a-button type="primary" style="margin-left: 8px">搜索</a-button>
      </a-row>
      <div class="tips">
        <a-alert banner>
          <div slot="message" class="message">
            1、发布后支队管理员/业务处室/消防员能在项目查询中能通过项目信息选项查询搜索；  <br />
            2、提交方申请退回后，可操作退回，如不进行退回，可继续当前业务流程。
          </div>
        </a-alert>
      </div>
      <div class="actions">
        <a-button type="primary">
          <a-icon type="plus" />
          新增项目立项
        </a-button>
      </div>
      <div class="data">
        <list-table :list="list">
          <div slot="data1" slot-scope="{ row }" :span="12">
            <span>项目编号:</span>
            <span>{{ row.data1 }}</span>
          </div>
          <div slot="data2" slot-scope="{ row }" :span="12">
            <span>项目领域:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data3" slot-scope="{ row }" :span="12">
            <span>项目联系人:</span>
            <span>{{ row.data2 }}</span>
          </div>
          <div slot="data4" slot-scope="{ row }" :span="12">
            <span>项目负责人:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data5" slot-scope="{ row }" :span="12">
            <span>发布单位:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data6" slot-scope="{ row }" :span="12">
            <span>新建时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data7" slot-scope="{ row }" :span="12">
            <span>提交时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data8" slot-scope="{ row }" :span="12">
            <span>申请退回时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data9" slot-scope="{ row }" :span="12">
            <span>退回时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="actions">
            <a-dropdown>
              <a-button >更多操作</a-button>
              <a-menu slot="overlay" >
                <a-menu-item key="1">申请退回</a-menu-item>
                <a-menu-item key="1">删除</a-menu-item>
                <a-menu-item key="1">预览</a-menu-item>
              </a-menu>
            </a-dropdown>

            <a-divider type="vertical" />
            <a-button type="primary">编辑</a-button>
            <a-divider type="vertical" />
            <a-button type="primary">提交</a-button>
          </div>
          <div slot="footer" slot-scope="{ row }" :span="12">
            <a-tag v-for="index in 30" :key="index" style="margin-bottom: 9px">Tag 1</a-tag>
          </div>
        </list-table>
      </div>
    </div>
  </div>
</template>

<script>
import TagCheckBox from '../../../components/TagCheckBox'
import ListTable from '../../../components/ListTable'
const PRIZE_STATUS_EMNU = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '待提交',
    value: '1',
  },
  {
    label: '待审核',
    value: '2',
  },
  {
    label: '审核通过',
    value: '3',
  },
  {
    label: '审核驳回',
    value: '4',
  },
  {
    label: '已发布',
    value: '5',
  },
  {
    label: '已下架',
    value: '6',
  },
  {
    label: '待退回',
    value: '7',
  },
  {
    label: '已退回',
    value: 'COUNTRY_PRIZE',
  },
]
const PRIZE_CATEGORY_EMNU = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '基础研究',
    value: '基础研究',
  },
  {
    label: '重点研发',
    value: '重点研发',
  },
  {
    label: '消防管理理论与软科学',
    value: '消防管理理论与软科学',
  },
  {
    label: '应用创新',
    value: '应用创新',
  },
  {
    label: '其他',
    value: '其他',
  },
]
export default {
  components: {
    TagCheckBox,
    ListTable,
  },
  data() {
    return {
      list: [
        {
          title: 'xxxxxxx',
          status: '',
          data1: '',
          data2: '',
          data3: '',
          data4: '',
          data5: '',
          data6: '',
          data7: '',
          data8: '',
          data9: '',
        },
      ],
      searchParams: {
        prizeStatusValue: [''],
        prizeCategoryValue: [''],
        searchType: 'PROJECT_NAME',
      },
      PRIZE_STATUS_EMNU,
      PRIZE_CATEGORY_EMNU,
    }
  },
}
</script>

<style lang="less" scoped>
.submit-container {
  background: #f0f2f5;
  .search-form {
    padding: 0 20px 20px;
    background: #fff;
  }
  .table {
    margin-top: 16px;
    background: #fff;
  }
  .search {
    padding: 24px 16px;
    border-bottom: 1px #f0f0f0 solid;
  }
  .tips {
    margin: 14px 15px;
    .message {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      font-weight: 400;
      line-height: 1.6;
      margin-left: 10px;
    }
  }
  .actions {
    margin: 14px 15px 0;
  }
  .data {
    padding: 0 14px 15px;
  }
}
</style>